import { ThemeConfig, theme } from "antd";
import { MapToken } from "antd/es/theme/interface";
const { defaultSeed: seedTokens } = theme;

/**
 * Note:
 * seedToken is base
 * mapToken extends seedToken
 * aliasToken extends mapToken
 * see definitions: https://github.com/ant-design/ant-design/blob/master/components/theme/themes/seed.ts
 * For more refer: https://ant.design/docs/react/customize-theme#design-token
 */

seedTokens.colorPrimary = "#5f259f";
seedTokens.colorLink = "#5f259f";

/**
 * Derived from seed token
 * {@link https://ant.design/docs/react/customize-theme#map-token From official docs}
 *
 * Override these values here. After AntD derives mapTokens from specified algorithm using seedToken
 * these values will be overwritten
 */
const mapTokens: Partial<MapToken> = {
    fontSizeHeading1: 30,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 18,
    fontSizeHeading5: 14,
    colorBgMask: "#344054B2",
    colorPrimaryBg: "#F9F5FF",
    // Derived from figma designs: lineHeight in px / fontSize in px
    lineHeight: 20 / 14,
    lineHeightHeading1: 40 / 30,
    lineHeightHeading2: 32 / 24,
    lineHeightHeading3: 28 / 20,
    lineHeightHeading4: 26 / 18,
    lineHeightLG: 24 / 16,
    lineHeightSM: 18 / 12,
};

const componentTokens: ThemeConfig["components"] = {
    Spin: { dotSizeSM: 32, dotSizeLG: 56, dotSize: 48, contentHeight: 400 },
    Tabs: {
        cardBg: "transparent",
        cardPadding: "8px 12px",
        cardPaddingLG: "10px 14px",
        colorBgContainer: "#F9F5FF",
        colorBorderSecondary: "transparent",
        colorBorder: "transparent",
    },
    Input: {
        paddingBlock: 4,
        paddingBlockLG: 7,
        paddingBlockSM: 0,
        paddingInline: 11,
        paddingInlineLG: 11,
    },
    Table: {
        borderColor: "#EAECF0",
        headerBg: "#F9FAFB",
        headerColor: "#475467",
        fontFamily: "Inter",
        cellFontSize: 14,
        stickyScrollBarBg: "#EAECF0",
    },
    Skeleton: {
        paragraphMarginTop: 16,
        blockRadius: 4,
    },
};

export { seedTokens, mapTokens, componentTokens };
